// extracted by mini-css-extract-plugin
export default {"title":"NotificationPage_title__WqYVQ"};